import React from "react";

const Search = ({ searchQuery, setSearchQuery, translations }) => {
  const placeholder = translations?.find(
    (translation) => translation.Key === "SearchHelpText"
  );
  return (
    <div className="search-container">
      <span className="icon-search"></span>
      <input
        type="text"
        placeholder={placeholder?.Translation}
        value={searchQuery}
        onChange={(event) => setSearchQuery(event.target.value)}
      />
    </div>
  );
};

export default Search;
